import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { scrollState } from "./scrollMath";
import { updateOverlays } from "./overlays";

gsap.registerPlugin(ScrollTrigger);

// Sets up a single ScrollTrigger as the source of truth for scroll progress.
export function useScrollController(triggerRef) {
  useEffect(() => {
    const el = triggerRef.current;
    if (!el) return;

    updateOverlays(0);

    const st = ScrollTrigger.create({
      trigger: el,
      start: "top top",
      end: "bottom bottom",
      invalidateOnRefresh: true,
      onUpdate: (self) => {
        scrollState.progress = self.progress;
        updateOverlays(self.progress);
      },
    });

    // Refresh after fonts / layout settle
    const t1 = setTimeout(() => ScrollTrigger.refresh(), 300);
    const t2 = setTimeout(() => ScrollTrigger.refresh(), 1200);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => ScrollTrigger.refresh());
    }

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      st.kill();
    };
  }, [triggerRef]);
}
